import { createReducer, on } from "@ngrx/store";
import { initialIntegrationState } from "./integrations.state";
import { UserActions } from "../user/user.actions";
import { IntegrationActions } from "./integrations.actions";
import { onLoadableLoad, onLoadableSuccess, arrayToILoadableWrapperArray, onLoadableError, toLoadableWrapper } from "../../models";
import { removeItem, replaceItem } from "../common";

export const integrationsReducer = createReducer(
    initialIntegrationState,
    on(IntegrationActions.loadIntegrations, state => ({
        ...state,
        integrations: {
            ...onLoadableLoad(state.integrations),
            items: []
        }
    })),
    on(IntegrationActions.loadIntegrationsSuccess, (state, { integrations }) => ({
        ...state,
        integrations: {
            ...onLoadableSuccess(state.integrations),
            items: arrayToILoadableWrapperArray(integrations)
        }
    })),
    on(IntegrationActions.loadIntegrationsFailure, (state, { error }) => ({
        ...state,
        integrations: {
            ...onLoadableError(state.integrations, error),
            items: []
        }
    })),

    on(IntegrationActions.deleteIntegration, (state, { integration }) => ({
        ...state,
        integrations: {
            ...state.integrations,
            items: replaceItem(state.integrations.items, {...onLoadableLoad(toLoadableWrapper(integration))})
        }
    })),
    on(IntegrationActions.deleteIntegrationSuccess, (state, { integration }) => ({
        ...state,
        integrations: {
            ...state.integrations,
            items: removeItem(state.integrations.items, integration.id)
        }
    })),
    on(IntegrationActions.deleteIntegrationFailure, (state, { integration, error }) => ({
        ...state,
        integrations: {
            ...state.integrations,
            items: replaceItem(state.integrations.items, {...onLoadableError(toLoadableWrapper(integration), error)})
        }
    })),
    on(IntegrationActions.loadBlueprints, state => ({
        ...state,
        blueprints: {
            ...onLoadableLoad(state.integrations),
            items: []
        }
    })),
    on(IntegrationActions.loadBlueprintsSuccess, (state, { blueprints }) => ({
        ...state,
        blueprints: {
            ...onLoadableSuccess(state.blueprints),
            items: arrayToILoadableWrapperArray(blueprints)
        }
    })),
    on(IntegrationActions.loadBlueprintsFailure, (state, { error }) => ({
        ...state,
        blueprints: {
            ...onLoadableError(state.blueprints, error),
            items: []
        }
    })),

    on(UserActions.logout, _ => ({ ...initialIntegrationState })),
)